// color-interpolation.service.ts
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ColorInterpolationService {
  public interpolateColor(startColor: string, endColor: string, factor: number): string {
    const parseHSL = (hsl: string): { h: number; s: number; l: number } => {
      const result = /hsl\((\d+),\s*(\d+)%?,\s*(\d+)%?\)/i.exec(hsl);
      if (!result) {
        throw new Error(`Invalid HSL color: ${hsl}`);
      }
      return {
        h: parseInt(result[1], 10),
        s: parseInt(result[2], 10),
        l: parseInt(result[3], 10),
      };
    };

    const start = parseHSL(startColor);
    const end = parseHSL(endColor);

    // Interpolate each component
    const h = start.h + (end.h - start.h) * factor;
    const s = start.s + (end.s - start.s) * factor;
    const l = start.l + (end.l - start.l) * factor;

    return `hsl(${h}, ${s}%, ${l}%)`;
  }
}
